module.exports = __webpack_public_path__ + "static/media/properties.7d457c59.svg";